<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>الصلاحيات</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class="panel panel-default">
                            <div class="panel-heading">
                                الصلاحيات
                            </div>
                            <!-- /.panel-heading -->
                            <div class='row' style="padding-left: 20px;padding-right: 20px;">
                            <div class='form-group col-lg-12 col-sm-12'>
                              <h4 >المجموعة:</h4>
                              <select  class="form-control" style="padding: 0px" @change="GetData($event.target.value)" v-model="UserGroup">
                                <option v-for="item in UserGroups" v-bind:key="item.id" v-bind:value="item">
                                  {{ item.display_name }}
                                </option>
                              </select>
                            </div>
                          </div>
                            <div class="panel-body">
                                <!-- Nav tabs -->
                                <div class="panel-group" id="accordion">

                                    <div class="panel panel-default" v-for="department in records" v-bind:key="department.id">
                                        <div class="panel-heading">
                                            <h4 class="panel-title">
                                                <a data-toggle="collapse" data-parent="#accordion" :href="'#collapse' + department.id">{{department.name}}</a>
                                            </h4>
                                        </div>
                                        <div :id="'collapse' + department.id" class="panel-collapse collapse">
                                            <div class="panel-body">
                                              <ul style="list-style-type: none;">
                                                <li v-for="itemx in department.permissions" :key="itemx.id">
                                                  <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                                                  <input v-show="$per.value.SaveRolePermission" type="checkbox" @change="chacked(itemx.name,itemx.permission)" v-model="itemx.permission" >
                                                  <small class="text-success" for="checkbox">{{ itemx.display_name }}</small>
                                                </li>
                                              </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                              </div>
                                                          <!-- /.panel-body -->
                        </div>
                                <!-- /.table-responsive -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
        </div>
</template>
<style >
.container {
display: flex;
border: 1px solid;
}
.col {
margin: 10px;
border: 1px solid;
flex-grow: 1;
display: flex;
flex-direction: column;
}
.item-container {
border: 1px solid;
padding: 5px;
margin: 5px;
}
</style>
<script>
import axios from 'axios'
export default {
  name: 'permission',
  data () {
    return {
      permissions_group: '',
      validationErrors: '',
      records: {},
      record: {},
      UserGroups: {},
      UserGroup: '',
      errorShow: false,
      department: '',
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false
    }
  },
  created () {
    this.getUserGroup()
  },
  methods: {
    // --------------------------------------------------
    getUserGroup () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getUserGroup', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.UserGroups = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    // --------------------------------------------------
    GetData (id) {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getDepartments', {
        token: localStorage.getItem('token'),
        department_name: id,
        rool_id: this.UserGroup.id

      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    // --------------------------------------------------
    chacked (id, permission) {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'SaveRolePermission', {
        token: localStorage.getItem('token'),
        permission: id,
        action: permission,
        rools: this.UserGroup.name
      })
        .then(({ data }) => {
          this.isLoadingSave = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/company/Permissions.vue